import { Component, OnDestroy, OnInit } from '@angular/core';
import { User } from 'src/app/models/user';
import { SettingsService } from '../../settings.service';
import { BreadCrumbOptions, SettingsBreadCrumbService } from '../../settings-breadcrumb.service';
import { Subscription } from 'rxjs';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { PermissionsEnum } from 'src/app/constants/settings.enum';

@Component({
  templateUrl: './general.page.html'
})
export class GeneralPage implements OnDestroy {
  
  // needed to setup Directives of Permission
  permissionEnum = PermissionsEnum;
  
  user!: User;
  twoFactorRequired: any;
  showAllDocsInOrg: boolean = false;
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;

  constructor(private settingsService: SettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
      if (organisationId === this.selectedOrganisationId) return;
      this.selectedOrganisationId = organisationId;
      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Security(this.selectedOrganisationId), BreadCrumbOptions.Security_General(this.selectedOrganisationId));

      this.getTwoFactorSettings();
    });

    this.user = this.settingsService.user;
    let showAllDocsInOrg = sessionStorage.getItem("ShowAllDocsInOrg");
    if (showAllDocsInOrg != undefined && showAllDocsInOrg != null && showAllDocsInOrg != "false") {
      this.showAllDocsInOrg = true;
    }
  }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }

  async getTwoFactorSettings() {
    (await this.settingsService.getTwoFactorrequired(this.selectedOrganisationId)).subscribe((data: any) => {
      this.twoFactorRequired = data;
    });
  }

  updateTwoFactor(event: any) {
    this.twoFactorRequired.twoFactorRequired = (event.target as HTMLInputElement).checked;
    this.settingsService.updateSettings({ key: "twoFactorRequired", body: this.twoFactorRequired.twoFactorRequired }, this.selectedOrganisationId)
  }

  updateAllDocsInOrg() {
    let ShowAllDocsInOrg = sessionStorage.getItem("ShowAllDocsInOrg");
    if (ShowAllDocsInOrg != undefined && ShowAllDocsInOrg != null && ShowAllDocsInOrg != "false") {
      sessionStorage.setItem("ShowAllDocsInOrg", "false");
      this.showAllDocsInOrg = false;
      this.settingsService.updateGeneralSettings({ key: "ShowAllDocsInOrg", body: "false" }, this.selectedOrganisationId);
    } else {
      sessionStorage.setItem("ShowAllDocsInOrg", "true");
      this.showAllDocsInOrg = true;
      this.settingsService.updateGeneralSettings({ key: "ShowAllDocsInOrg", body: "true" }, this.selectedOrganisationId);
    }
  }
}
